import React from "react";
import "./CareerModal.css";
import CareersFormEnquery from "./CareersFormEnquery";

export default function CareerModal({ show, onClose, position }) {
  return (
    <>
      {show && (
        <div
          className="modal fade show"
          style={{ display: "block" }}
          role="dialog"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title text-light">Join Our Team</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={onClose}
                ></button>
              </div>
              <div className="modal-body">
                <div className="modal-box">
                  <CareersFormEnquery />
                  {/* <form
                    method="post"
                    action="apply.php"
                    encType="multipart/form-data"
                  >
                    <div className="row g-3">
                      <div className="col-md-6 form-group">
                        <input
                          name="name"
                          type="text"
                          placeholder="Your Name *"
                          required
                          className="form-control"
                        />
                      </div>
                      <div className="col-md-6 form-group">
                        <input
                          name="email"
                          type="email"
                          placeholder="Your Email *"
                          required
                          className="form-control"
                        />
                      </div>
                      <div className="col-md-6 form-group">
                        <input
                          name="number"
                          type="tel"
                          pattern="[789][0-9]{9}"
                          placeholder="Your Number *"
                          required
                          className="form-control"
                        />
                      </div>
                      <div className="col-md-6 form-group">
                        <select
                          name="position"
                          required
                          className="form-select"
                        >
                          <option value="">Select</option>
                          <option value="Sales Manager">Sales Manager</option>
                          <option value="Real Estate Sales Executive">
                            Real Estate Sales Executive
                          </option>
                          <option value="Real Estate Accountant">
                            Real Estate Accountant
                          </option>
                          <option value="Pre-Sales Executive">
                            Pre-Sales Executive
                          </option>
                          <option value="Office Assistant">
                            Office Assistant
                          </option>
                          <option value="Office Assistant">Other</option>
                        </select>
                      </div>

                      <div className="col-md-12 form-group">
                        <input
                          type="file"
                          id="myFile"
                          name="userfile"
                          accept=".doc, .docx, .pdf"
                          required
                          className="form-control"
                        />
                      </div>

                      <div className="col-12 text-center">
                        <button
                          type="submit"
                          className="modal-button theme-btn"
                        >
                          Send Message
                        </button>
                      </div>
                    </div>
                  </form> */}
                </div>
              </div>
            </div>
          </div>

          {/* Modal backdrop */}
          <div className="modal-backdrop fade show" onClick={onClose}></div>
        </div>
      )}
    </>
  );
}
